import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-lt",
  "use": "icon-icon-lt-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-lt\">\n  <g fill-rule=\"evenodd\" stroke-width=\"1pt\" transform=\"scale(.51314 1.0322)\">\n    <rect width=\"1063\" height=\"708.7\" fill=\"#006a44\" rx=\"0\" ry=\"0\" transform=\"scale(.93865 .69686)\" />\n    <rect width=\"1063\" height=\"236.2\" y=\"475.6\" fill=\"#c1272d\" rx=\"0\" ry=\"0\" transform=\"scale(.93865 .69686)\" />\n    <path fill=\"#fdb913\" d=\"M0 0h997.8v164.6H0z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol